export default __webpack_public_path__ + "static/media/senior-sample3-sc.26e7291d.png";